import React, { JSX } from 'react';
import { Box, Typography } from '@mui/material';
import { widget } from '../customDashboard/types';
import AverageCostPerPalletSpace from '../widgets/costPerPalletSpace';
import DashboardNewsFeed from '../widgets/DashboardNewsFeed';
import RevenueWidget from '../widgets/revenue';
import TotalDiscrepancies from '../widgets/totalDiscrepancies';
import TotalOrders from '../widgets/totalOrders';
import OrdersListWidget from '../widgets/orderList/orderList';
import ConsignmentBreakdownWidget from '../widgets/consignmentbreakdown';
import RevenueTotalWidget from '../widgets/revenuetotal';
import ConsignmentMap from '../widgets/consignmentMap';
import TotalRevenueFigureWidget from '../widgets/totalRevenueFigure';
import ConsignmentsOnTimeWidget from '../widgets/consignmentsOnTime';

const FallBackComponent = ({ name }: { name: string }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
      <Typography>{`Component '${name}' not created`}</Typography>
    </Box>
  );
};

const componentLookup = (widget: widget): JSX.Element => {
  const lookup = {
    AverageCostPerPalletSpace: <AverageCostPerPalletSpace />,
    DashboardNewsFeed: <DashboardNewsFeed />,
    RevenueWidget: <RevenueWidget />,
    TotalDiscrepancies: <TotalDiscrepancies />,
    TotalOrders: <TotalOrders />,
    orderList: <OrdersListWidget />,
    consignmentBreakdownWidget: <ConsignmentBreakdownWidget />,
    revenueTotalWidget: <RevenueTotalWidget />,
    ConsignmentMap: <ConsignmentMap />,
    TotalRevenueFigureWidget: <TotalRevenueFigureWidget />,
    ConsignmentsOnTimeWidget: <ConsignmentsOnTimeWidget />
  };

  const component = lookup[widget.type as keyof typeof lookup];

  if (!component) {
    return <FallBackComponent name={widget.type} />;
  }

  return component;
};

export default componentLookup;
